import {effect} from 'utils/redux';
import {catchNonFatalDefault} from 'io/errors';
import {ensureAccess, setPageTitleMessage, decorateWithNotifications} from 'io/app';
import namespace from './namespace';
import * as actions from './actions';
import * as commonSelectors from 'modules/common/selectors';
import {appName} from '../constants';
import {getLists as ioSearchLists} from './io';

const creator = effect(namespace);

export let initialize = () => (getState, dispatch) => {
	setPageTitleMessage('Calendar [app]')(getState, dispatch);

	ensureAccess(appName, commonSelectors.user(getState()))(getState, dispatch)
		.then(() => {
			dispatch(actions._initialize());
		})
		.catch(catchNonFatalDefault(getState, dispatch));
};
initialize = creator('initialize', initialize);

export let searchLists =
	({text, callback, query = {}}) =>
	(getState, dispatch) => {
		decorateWithNotifications(
			{
				id: 'search-lists',
				failureStyle: 'warning',
			},
			ioSearchLists({_limit: 999, title: text}),
		)(getState, dispatch)
			.then(users => {
				callback(users);
			})
			.catch(catchNonFatalDefault(getState, dispatch));
	};
searchLists = creator('searchLists', searchLists);
